import React, { Component } from 'react';
import StageFilter from "./stageFilter";
import MetastasisFilter from "./metastasisFilter";
import AlcoholFilter from "./alcoholFilter";
import SmokingFilter from "./smokingFilter";
import GenderFilter from "./genderFilter";
import TreatmentFilter from "./treatmentFilter";
import MalignancyFilter from "./malignancyFilter";
import AgeFilter from "./ageFilter";

class ClinicalFilters extends Component{
    render() {
        return (
            <div className="filter-wrapper">
                <TreatmentFilter
                    registerRequest={this.props.registerRequest}
                    registerResponse={this.props.registerResponse}
                    unregisterRequest={this.props.unregisterRequest}
                    unregisterResponse={this.props.unregisterResponse}/>
                <MetastasisFilter
                    registerRequest={this.props.registerRequest}
                    registerResponse={this.props.registerResponse}
                    unregisterRequest={this.props.unregisterRequest}
                    unregisterResponse={this.props.unregisterResponse}/>
                <StageFilter
                    registerRequest={this.props.registerRequest}
                    registerResponse={this.props.registerResponse}
                    unregisterRequest={this.props.unregisterRequest}
                    unregisterResponse={this.props.unregisterResponse}/>
                <MalignancyFilter
                    registerRequest={this.props.registerRequest}
                    registerResponse={this.props.registerResponse}
                    unregisterRequest={this.props.unregisterRequest}
                    unregisterResponse={this.props.unregisterResponse}/>
                <AlcoholFilter
                    registerRequest={this.props.registerRequest}
                    registerResponse={this.props.registerResponse}
                    unregisterRequest={this.props.unregisterRequest}
                    unregisterResponse={this.props.unregisterResponse}/>
                <SmokingFilter
                    registerRequest={this.props.registerRequest}
                    registerResponse={this.props.registerResponse}
                    unregisterRequest={this.props.unregisterRequest}
                    unregisterResponse={this.props.unregisterResponse}/>
                <AgeFilter
                    registerRequest={this.props.registerRequest}
                    registerResponse={this.props.registerResponse}
                    unregisterRequest={this.props.unregisterRequest}
                    unregisterResponse={this.props.unregisterResponse}/>
                <GenderFilter
                    registerRequest={this.props.registerRequest}
                    registerResponse={this.props.registerResponse}
                    unregisterRequest={this.props.unregisterRequest}
                    unregisterResponse={this.props.unregisterResponse}/>
            </div>
        )
    }
}

export default ClinicalFilters;
